<div class="tw-w-full">
    <div class="tw-h-1.5 tw-w-full tw-bg-gray-200 tw-overflow-hidden tw-rounded-xl" [ngClass]="{'tw-flex tw-justify-end': isReversed}">
      <div class="tw-w-full tw-h-full tw-rounded-xl {{ classColor }}" [ngClass]="{'progress left-right': isInfinite}" [style.width.%]="progress"></div>
    </div>
</div>